var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Desktop'),_c('div',{staticClass:"sorry",on:{"click":function($event){return _vm.sorry()}}},[_c('div',{staticClass:"sorry-btn"},[_vm._v("I'm sorry")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }